import { api } from "roboflex-thalamus-request-handler";
import { DeviceModel } from "../models/DeviceModel";

export default class DeviceDataSource {
  /**
   * Lista dispositivos - apenas dados básicos.
   */
  async getDevices(page = 1, perPage = 10, search = "") {
    const params = new URLSearchParams({
      page: page.toString(),
      per_page: perPage.toString(),
    });

    if (search) {
      params.append("search", search);
    }

    const response = await api.get(`dispositivo?${params.toString()}`);

    const devices = response.data.data.map((element) => DeviceModel.fromJson(element));

    return {
      devices,
      pagination: {
        currentPage: response.data.current_page,
        lastPage: response.data.last_page,
        perPage: response.data.per_page,
        total: response.data.total,
      },
    };
  }

  /**
   * Busca detalhes completos de um dispositivo.
   */
  async getDeviceDetails(id) {
    const response = await api.get(`dispositivo/${id}/detalhes`);
    return DeviceModel.fromJsonDetalhes(response.data);
  }
}
